export default "/_next/static/images/ef1b84d0d8a807d6ba41edb095aec5e0.jpg";